/**
 * Get table headers for viewer or admin.
 *
 * @returns array of table headers.
 */
export const getHeaders = (): string[] => {
  const headers = [
    'Company name',
    'Old name',
    'Legal name',
    'Registration',
    'Industry',
    'group',
    'Company stage',
    'Responsible managers',
    'Website',
    'Description',
  ];
  return headers;
};
